import React, { useEffect, useState } from 'react';

import CollapsibleCardView from '../../common/CardView/CollapsibleCardView';
import EngineIcon from '../../common/icons/EngineIcon';
import ErrorLabel from '../../common/Labels/ErrorLabel';
import Icon from '../../common/icons/Icon';

import { getThemeColor } from '../../../utils/theme-utils';
import { isJSON } from '../../../utils/text_utils';

import EditableJSONView from '../../common/EditableJSONView/NewEditableJSONView';

export const PipelineEngineConfigView = ({
  engineConfig,
  onSave = () => {},
  disableEdit = false,
  enableEdit = false,
}) => {
  const [editedConfig, setEditedConfig] = useState(engineConfig);
  const [isEditing, setIsEditing] = useState(false);

  const editError = isJSON(editedConfig) ? null : 'Invalid JSON';

  const onSaveClick = () => {
    onSave(editedConfig);
    setIsEditing(false);
  }
  const onCancelClick = () => {
    setEditedConfig(engineConfig);
    setIsEditing(false);
  }
  const onEditClick = () => setIsEditing(true);

  const actions = isEditing ? [
    {
      label: 'Save and Deploy',
      variant: 'primary',
      onClick: onSaveClick,
      disabled: editError,
      disabledText: editError,
    },
    {
      label: 'Cancel',
      variant: 'danger',
      onClick: onCancelClick,
    }
  ] : [
    {
      label: 'Edit',
      variant: 'brand',
      onClick: onEditClick,
      disabled: disableEdit || !engineConfig,
      disabledText: 'Cannot edit the configuration for a deployed pipeline.'
    }
  ];

  useEffect(() => {
    if (engineConfig && !editedConfig && !isEditing) {
      setEditedConfig(engineConfig);
    }
  }, [editedConfig, engineConfig, isEditing])

  return (
    <CollapsibleCardView headerText="Deployment Configuration" icon={EngineIcon} quickActionsArray={enableEdit ? actions : []}>
      {
        engineConfig ? (
          <div className="px-4 overflow-y-scroll">
            <EditableJSONView
              data={isEditing ? editedConfig : engineConfig}
              enableEdit={isEditing}
              setData={setEditedConfig}
              restrictedProps={['workspace_id', 'enginelb']}
            />
          </div>
        ) : (
          <div className="p-4 flex-grow flex flex-col justify-center items-center">
            <Icon
              fill={getThemeColor('brand')}
              icon={EngineIcon}
              size={64}
              useTailwindSizing
            />
            <ErrorLabel>Could not locate engine configuration</ErrorLabel>
          </div>
        )
      }
    </CollapsibleCardView>
  )
}

export default PipelineEngineConfigView;
